<!-- 结果弹窗 -->
<template>
  <div class="result-popup">
    <van-overlay
      :show="show"
      @click="close"
      :lock-scroll="false"
      class="my-overlay"
    >
      <div class="wrapper" @click.stop>
        <img
          v-if="iconMap[iconKey]"
          class="pic"
          :src="iconMap[iconKey]"
          alt=""
        />
        <p class="title">{{ title }}</p>
        <p class="text">{{ message }}</p>
        <img
          v-if="isClose"
          class="btn"
          @click="close"
          :src="require(`@/assets/imgs/minfengBankSuqianRefuel/pic11.png`)"
          alt=""
        />
      </div>
      <img
        v-if="isClose"
        class="close"
        @click="close"
        :src="require(`@/assets/imgs/minfengBankSuqianRefuel/pic5.png`)"
        alt=""
      />
    </van-overlay>
  </div>
</template>
<script>
import { Toast } from 'vant'
export default {
  components: {},
  props: [],
  data() {
    return {
      show: false,
      iconMap: {
        0: require(`@/assets/imgs/minfengBankSuqianRefuel/icon0.png`),
        1: require(`@/assets/imgs/minfengBankSuqianRefuel/icon1.png`),
      },
      iconKey: '',
      title: '',
      message: '您已参与本次活动，无法再次参与~',
      isClose: false

    }
  },
  methods: {
    close() {
      if (!this.isClose) return
      this.setShow(false)
    },
    setShow(val) {
      this.show = val
    },
  },
}
</script>
<style lang="less" scoped>
.result-popup {
  position: relative;
  .my-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .wrapper {
    margin: 0 10px 0 30px;
    padding: 30px 40px 10px 20px;
    width: 250px;
    height: 280px;
    box-sizing: border-box;
    background: url("../../../../assets/imgs/minfengBankSuqianRefuel/pic12.png")
      no-repeat;
    background-size: 100% auto;
    text-align: center;
    font-size: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .pic {
      width: 55px;
    }
    .title {
      padding: 10px 0;
      line-height: 1.2;
      font-weight: bold;
      font-size: 20px;
      color: #36240a;
    }
    .text {
      line-height: 1.2;
      font-size: 12px;
      color: #806e57;
    }
    .btn {
      margin-top: 35px;
      width: 109px;
    }
  }
  .close {
    margin-top: 20px;
    width: 35px;
  }
}
</style>
